import { useParams } from 'react-router';
import { ScreenSkeleton } from '../../../components/atoms/ScreenSkeleton';
import { ShoeDriveLugScreen } from './shoes/ShoeDriveLugScreen';
import { DriveTumblerDriveLugScreen } from './driveTumbler/DriveTumblerDriveLugScreen';
export const DriveLugFactoryScreen = () => {
  const { partCategory } = useParams();

  switch (partCategory) {
    case 'shoes':
      return <ShoeDriveLugScreen />;
    case 'drive-tumbler':
      return <DriveTumblerDriveLugScreen />;
    default:
      return <ScreenSkeleton fields={4} />;
  }
};
